






import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import numeral from 'numeral'

@Component({
  components: {
  }
})
export default class GrowingNumber extends Vue {

  newValue = 0;
  step = 0;

  @Prop({ default: '',  type: String}) prefix!: string;
  @Prop({ default: '',  type: String}) suffix!: string;
  @Prop({ default: 0,  type: Number}) value!: number;
  @Prop({ default: 500,  type: Number}) duration!: number;
  @Prop({ default: false,  type: Boolean}) showDecimals!: boolean;

  mounted() {
    console.log('init');
    this.growInit()
  }

  @Watch('value')
  onValueChange(){
    this.growInit();
  }

  growInit () {
    const m = this.value / (this.duration / 25)
    this.grow(m)
  }

  grow (m:number) {
    const v = Math.ceil(this.newValue + m)
    if (v > this.value) {
      this.newValue = this.value
      return false
    }
    this.newValue = v
    setTimeout(() => {
      this.grow(m)
    }, 25)
  }

  get newValueFormatted():string|number {
    
    if(this.showDecimals)
      return numeral(this.newValue).format('0,0.00')
    else
      return numeral(this.newValue).format('0,0')
  }
}

